import {Routes} from '@angular/router'
import {LoginComponent} from './ui/login/login.component'

export const routes: Routes = [
  {
    path: '',
    children: [
      {
        path: 'login',
        component: LoginComponent
      },
      {
        path: 'home',
        loadComponent: () => import('./ui/home/home.component').then(c => c.HomeComponent)
      },
      {
        path: 'admin',
        loadChildren: () => import('./admin/admin.routes')
      },
      {
        path: '**',
        pathMatch: 'full',
        redirectTo: 'login'
      }
    ]
  }
]
